import axios from 'axios';
import config from '../config';

/**
 * Upload optional sale / intake photo (non-blocking friendly).
 * @returns {Promise<{ success: boolean, photoUrl?: string, error?: string }>}
 */
export async function uploadSalePhoto(file, meta) {
  if (!file) return { success: true, skipped: true };
  try {
    const fd = new FormData();
    fd.append('salePhoto', file);
    if (meta.customerId) fd.append('customerId', meta.customerId);
    if (meta.kind) fd.append('kind', meta.kind);
    if (meta.emiId) fd.append('emiId', String(meta.emiId));
    if (meta.productId) fd.append('productId', String(meta.productId));
    if (meta.productSaleId) fd.append('productSaleId', String(meta.productSaleId));
    if (meta.imeiIndex != null && meta.imeiIndex !== '') {
      fd.append('imeiIndex', String(meta.imeiIndex));
    }

    const res = await axios.post(`${config.API_URL}/sale-media`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000
    });
    return { success: true, photoUrl: res.data?.photoUrl };
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Photo upload failed';
    console.warn('[uploadSalePhoto]', msg);
    return { success: false, error: msg };
  }
}
